import { render, staticRenderFns } from "./ActivityTemplateImports.vue?vue&type=template&id=49976f20&"
import script from "./ActivityTemplateImports.vue?vue&type=script&lang=js&"
export * from "./ActivityTemplateImports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports